{
  "version": 1,
  "asset_id": "c8b03c02-1c5d-48ba-97d8-120ff9476a26",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/c8b03c02-1c5d-48ba-97d8-120ff9476a26/bahcesehir-hizli-elektrikci-7-24-dukkan-5.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/c8b03c02-1c5d-48ba-97d8-120ff9476a26/bahcesehir-hizli-elektrikci-7-24-dukkan-5.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-5.jpg",
  "size": 497801,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:18:52Z"
}
